(async () => {

    const { Core } = await importModule('Core');

    customElements.define('product-options-dropdown', class extends Core {
        elements = {
            dropdown: 'drop-down',
            current: '[data-current]'
        }

        render() {
            this._handleChange();
        }

        _handleChange() {
            this.addEventListener('change', this._onChange.bind(this));
        }

        async _onChange({ target }) {
            this.$current.textContent = target.value;
            // Gallery changes can arrive before the dropdown element upgrades.
            await customElements.whenDefined('drop-down');
            if (this.isConnected && typeof this.$dropdown?.close === 'function') {
                this.$dropdown.close();
            }
        }
    });

})();